import Nullstack from 'nullstack';
export default function IconBrandVsco({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-vsco",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
  }), "   ", Nullstack.element("path", {
    d: "M17 12a5 5 0 1 0 -10 0a5 5 0 0 0 10 0z"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v4"
  }), "   ", Nullstack.element("path", {
    d: "M21 12h-4"
  }), "   ", Nullstack.element("path", {
    d: "M12 21v-4"
  }), "   ", Nullstack.element("path", {
    d: "M3 12h4"
  }), "   ", Nullstack.element("path", {
    d: "M18.364 5.636l-2.828 2.828"
  }), "   ", Nullstack.element("path", {
    d: "M18.364 18.364l-2.828 -2.828"
  }), "   ", Nullstack.element("path", {
    d: "M5.636 18.364l2.828 -2.828"
  }), "   ", Nullstack.element("path", {
    d: "M5.636 5.636l2.828 2.828"
  }), " ");
}